import type { CmsPageData } from '@/app/lib/api/types-api'
import { ALL_LOCATIONS } from '@/app/lib/constants'
import { resolveProvinceLabel } from '@/app/lib/utils/province-mapping'

const BRAND_SUFFIX = ' | Entradas El Corte Inglés'

/**
 * `<title>` de una página CMS genérica — `personalization_title` cuando llega
 * con contenido (no `null`/vacío tras `trim()`) tiene prioridad siempre; si
 * no, `name` + sufijo de marca — con la provincia insertada
 * ("{name} en {provincia}") cuando `location` es una página de categoría
 * localizada (distinta de `ALL_LOCATIONS`/`undefined`, p. ej.
 * `/entradas/conciertos/madrid/`). A diferencia de `resolvePageHeading` (H1),
 * `personalization_title` SÍ trae ya la marca cuando el CMS lo define — no se
 * le añade el sufijo encima.
 */
export function resolveCmsPageTitle(
  page: Pick<CmsPageData, 'name' | 'personalization_title'>,
  location?: string,
): string {
  const personalizationTitle = page.personalization_title?.trim()
  if (personalizationTitle) return personalizationTitle

  const name = page.name ?? ''
  if (location && location !== ALL_LOCATIONS) {
    return `${name} en ${resolveProvinceLabel(location)}${BRAND_SUFFIX}`
  }
  return `${name}${BRAND_SUFFIX}`
}
